module.exports = __webpack_public_path__ + "static/media/Ara Matevosyan.9673d11a.pdf";